<template>
  <div class="product-introduction">
    <div class="product-container w">
      <div class="product-item" :class="item.className" v-for="item of productList" :key="item.className">
        <div class="title" :style="item.titleStyle">{{ item.title }}</div>
        <div class="img">
          <img :src="item.imgUrl" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductIntroduction',
  data () {
    return {
      productList: [
        {
          className: 'mobile-dzg',
          title: '移动大掌柜',
          titleStyle: 'margin-bottom: 30px',
          imgUrl: 'img/ProductIntroduction/mobile-dzg.png'
        }
      ]
    }
  },
  mounted() {
    // 初次进入页面手动调用一次
    if (this.scrollItem) {
      this.goSolutionItem(this.scrollItem)
    }
  },
  computed: {
    scrollItem() {
      return this.$store.state.scrollItem
    }
  },
  watch: {
    scrollItem(item) {
      this.goSolutionItem(item)
    }
  },
  methods: {
    // 滑动到指定项
    goSolutionItem(className) {
      this.backTimer = -1
      const classItem = document.getElementsByClassName(className)[0]
      const targetLocation = classItem.offsetTop - 64 - 30 // 30为padding-top的距离，使感官更友好
      const top =
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            window.pageYOffset
      let currentTop = top
      if (this.backTimer === -1) {
        this.speed = 40
        this.backTimer = setInterval(() => {
          if (Math.abs(currentTop - targetLocation) < this.speed) {
            this.speed = Math.abs(currentTop - targetLocation)
          }
          if (targetLocation < currentTop) {
            currentTop -= this.speed
          }
          if (targetLocation > currentTop) {
            currentTop += this.speed
          }
          window.scrollTo(0, currentTop)
          if (currentTop === targetLocation) {
            window.clearInterval(this.backTimer)
            this.backTimer = -1
          }
          this.speed += 15
        }, 10)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.product-introduction {
  width: 100%;
  height: auto;
  background-color: $bgcolor-main;
  user-select: none;
  .product-container {
    padding-top: 30px;
    .product-item {
      width: 100%;
      margin-bottom: 60px;
      .title {
        position: relative;
        padding-left: 16px;
        line-height: 28px;
        font-size: $fontsize-main;
        font-weight: $fontweight-highlight;
        color: $fontcolor-main;
      }
      .title::before {
        position: absolute;
        left: 0;
        bottom: 0;
        content: "";
        width: 6px;
        height: 28px;
        background-color: $bgcolor-theme;
      }
      .describe {
        font-size: $fontsize-describe;
        color: $fontcolor-main;
        .per-paragraph {
          text-indent: 2em;
        }
      }
      .img {
        width: 100%;
        height: auto;
        img {
          width: 1200px;
        }
      }
    }
  }
}
</style>
